//import * as types from '../constants';

const initialState = {

};

export default function localStorageReducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/demo/reducers/localStorage.js